import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './data-services/store';
import App from './App/App';
import AppMenuStickyRight from "./App/AppMenuStickyRight";
import AppMenuStickyLeft from "./App/AppMenuStickyLeft";
import CRSOutline from "../../custom-pages/product-course/crs-outline/src-outline";
import ProductMoreCourses from "../../custom-pages/product-course/more-courses/more-courses";
import TechSpecs from "../tech-specs/tech-specs";
import QuotesGallery from "../../galleries/quote-gallery/quote-gallery";
import ProductComparisonChart from "../product-comparison-chart/product-comparison-chart";
import {getJSONFromHtml} from "../../../domain/common";
import {IListItem} from "../../list-page/interfaces/interfaces";
import StickyMenu from "../../menus/menu-sticky/App/App";
import { tiktokProductPagesViewContent } from '../../../domain/marketing/tiktok-provider';
import { facebookProductPagesViewContent } from '../../../domain/facebook/facebook-marketing-provider';
import {rewriteWavesalias} from "./data-services/data-service";
import { round1DecimalPlace } from '../../../domain/math-provider';

/**
 * entry point
 */
const init = () => {

    //console.log('product-page-price-app');
    const $root = document.getElementById('product-page-price-app');
    if (!$root)
        return;
    else{
        ReactDOM.render(
            <React.StrictMode>
                <Provider store={ store }>
                    <App />
                </Provider>
            </React.StrictMode>,
            $root
        );
    }




    const $menuStickyLeft = document.getElementById('product-menu-sticky-left');
    if (!$menuStickyLeft)
        return;
    else {

        ReactDOM.render(
            <React.StrictMode>
                <Provider store={store}>
                    <AppMenuStickyLeft/>
                </Provider>
            </React.StrictMode>,
            $menuStickyLeft
        );
    }

    const $menuStickyRight = document.getElementById('product-menu-sticky-right');
    if (!$menuStickyRight)
        return;
    else{

        ReactDOM.render(
            <React.StrictMode>
                <Provider store={ store }>
                    <AppMenuStickyRight />
                </Provider>
            </React.StrictMode>,
            $menuStickyRight
        );
    }

    const $productTechSpecs = document.getElementById('tech-specs-app');
    if ($productTechSpecs)
    {
        ReactDOM.render(
            <React.StrictMode>
                <Provider store={ store }>
                    <TechSpecs />
                </Provider>
            </React.StrictMode>,
            $productTechSpecs
        );
    }

    const $productStickyMenu = document.getElementById('menu-sticky-json-app');
    if ($productStickyMenu){
        ReactDOM.render(
            <React.StrictMode>
                <Provider store={store}>
                    <StickyMenu />
                </Provider>
            </React.StrictMode>,
            $productStickyMenu
        );
    }






    const $quotesGalleryApp = document.getElementById('product-quote-gallery-app');
    //console.log('$quotesGalleryApp: ',$quotesGalleryApp);
    if ($quotesGalleryApp)
    {
        ReactDOM.render(
            <React.StrictMode>
                <Provider store={ store }>
                    <QuotesGallery />
                </Provider>
            </React.StrictMode>,
            $quotesGalleryApp
        );
    }

    const $productComparisonChart = document.getElementById('product-comparison-chart');

    if ($productComparisonChart)
    {
        const elComparisonSkunumber = document.querySelectorAll("[data-comparison-skunumber]");
        const productComparisonChartJson = getJSONFromHtml(document.getElementById('product-comparison-chart-data')) as IListItem[];
        elComparisonSkunumber.forEach(function(el:any) {
            const skuNumber = el.getAttribute('data-comparison-skunumber');
            const pFind = productComparisonChartJson.find(p => p.skuNumber === skuNumber);

            ReactDOM.render(
                <React.StrictMode>
                    <Provider store={ store }>
                        <ProductComparisonChart skuNumber={skuNumber} product={pFind} />
                    </Provider>
                </React.StrictMode>,
                el
            );

        });
    }

    const $courseOutline = document.getElementById('product-page-course-outline-app');

    if ($courseOutline)
    {
        ReactDOM.render(
            <CRSOutline />,
            $courseOutline
        );
    }

    const $productMoreCourses = document.getElementById('product-page-more-courses-app');

    if ($productMoreCourses)
    {
        ReactDOM.render(
            <ProductMoreCourses />,
            $productMoreCourses
        );
    }

    // init marketing scripts ----------------
    window.tiktokProductPagesViewContent = tiktokProductPagesViewContent;
    window.facebookProductPagesViewContent = facebookProductPagesViewContent;
};


rewriteWavesalias()
init();

/**
 * https://wavesaudio.atlassian.net/browse/MRKT-23296
 */
const handleRatingABTest = () => {
    const $rating = document.querySelector('.rating-server');
    if(!$rating) return;

    const rating = Number($rating.getAttribute('data-rating')) || 0;
    if(rating === 0) return;

    const $div = document.createElement('div');
    $div.className = 'line-height-normal text-sm font-bold text-white mr-1';
    $div.textContent = round1DecimalPlace(rating).toString();
    $rating.prepend($div);

    const $stars = $rating.querySelector('.star-rating') as HTMLElement;
    if(!$stars) return;
    $stars.style.marginTop = '-3px';
};

window.addEventListener('DOMContentLoaded', (event) => {

    const elPH: any = document.getElementById("sticky-place-holder");
    const el: any = document.getElementById("sticky");
    const offset = elPH.offsetTop - 10 ;
    if (offset < window.pageYOffset) {
        //console.log(`add: ${offset} | ${window.pageYOffset}`);
        el.classList.add("pinned");
        document.body.classList.add("menu-pinned");
    }

    window.addEventListener("scroll", function() {
        if (offset < window.pageYOffset) {
            //console.log(`add: ${offset} | ${window.pageYOffset}`);
            el.classList.add("pinned");
            document.body.classList.add("menu-pinned");
        } else if(offset - 40 > window.pageYOffset){
            //console.log(`remove: ${offset} | ${window.pageYOffset}`);
            el.classList.remove("pinned");
            document.body.classList.remove("menu-pinned");
        }
    }, false);
    //console.log('el:',el);
    /*const observer = new IntersectionObserver(
        ([e]) => {  e.target.classList.toggle("pinned", e.intersectionRatio < 1);document.body.classList.toggle("menu-pinned", e.intersectionRatio < 1)},
        { threshold: [1] }
    );
    const el: any = document.getElementById("sticky");
    if(el)
    observer.observe(el);*/

    //const $yotpo = document.getElementById('tab-reviews');
    //if($yotpo) {
        //console.log('$yotpo: ', $yotpo);
    //    YotpoPreview.Init();
    //}

    // https://wavesaudio.atlassian.net/browse/MRKT-23296
    handleRatingABTest();
});
export {};
